import React from 'react';
import { motion } from 'framer-motion';
import { Search, EyeOff, ShoppingCart } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export const Pain = () => {
  const {
    t
  } = useLanguage();
  return <section className="relative py-32 bg-background overflow-hidden" data-id="element-157">
      {/* Subtle fog effect */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white/[0.03] via-background to-background pointer-events-none" data-id="element-158" />

      <div className="container mx-auto px-6 relative z-10 text-center" data-id="element-159">
        <motion.h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight max-w-4xl mx-auto" initial={{
        opacity: 0,
        y: -50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-160">
          {t('pain.headline')}
        </motion.h2>
        <motion.p className="text-xl md:text-3xl text-text-secondary mb-20 font-serif italic" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.8
      }} data-id="element-161">
          {t('pain.subheadline')}
        </motion.p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-12 md:gap-20 mb-24" data-id="element-162">
          {[{
          icon: Search,
          text: t('pain.icon1'),
          delay: 0
        }, {
          icon: EyeOff,
          text: t('pain.icon2'),
          delay: 0.4
        }, {
          icon: ShoppingCart,
          text: t('pain.icon3'),
          delay: 0.8
        }].map((item, index) => <motion.div key={index} className="flex flex-col items-center" initial={{
          opacity: 0,
          x: index === 0 ? -50 : index === 2 ? 50 : 0,
          y: index === 1 ? 50 : 0
        }} whileInView={{
          opacity: 1,
          x: 0,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: item.delay,
          duration: 0.6,
          type: 'spring'
        }} data-id="element-163">
              <motion.div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center mb-6 text-red-500" whileInView={{
            rotate: [0, -10, 10, -10, 10, 0]
          }} viewport={{
            once: true
          }} transition={{
            delay: item.delay + 0.5,
            duration: 0.5
          }} data-id="element-164">
                <item.icon size={40} data-id="element-165" />
              </motion.div>
              <p className="text-lg font-medium text-text-secondary" data-id="element-166">
                ❌ {item.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-167">
          <motion.p className="text-red-500 font-bold text-xl md:text-2xl mb-12 tracking-widest uppercase" animate={{
          opacity: [0.5, 1, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-168">
            {t('pain.pulsing')}
          </motion.p>

          <div className="inline-block relative" data-id="element-169">
            <h3 className="text-2xl md:text-4xl font-serif font-bold text-white mb-2" data-id="element-170">
              {t('pain.closing1')}
            </h3>
            <h3 className="text-2xl md:text-4xl font-serif font-bold text-primary relative inline-block" data-id="element-171">
              {t('pain.closing2')}
              <motion.svg className="absolute -bottom-2 left-0 w-full h-3 text-primary" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-172">
                <motion.path d="M0 5 Q 50 10 100 5" fill="transparent" stroke="currentColor" strokeWidth="3" initial={{
                pathLength: 0
              }} whileInView={{
                pathLength: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 1,
                delay: 0.5,
                ease: 'easeInOut'
              }} data-id="element-173" />
              </motion.svg>
            </h3>
          </div>
        </motion.div>
      </div>
    </section>;
};